import { Component, OnInit, ElementRef, Injector, Input, Output, EventEmitter } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { MonitoredTrain } from '../../models/monitored-train';

@Component({
  selector: 'app-monitored-trains-map-upgraded',
  template: require('./monitored-trains-map-upgraded.component.html'),
  styles: [require('./monitored-trains-map-upgraded.component.sass')]
})
export class MonitoredTrainsMapUpgradedComponent extends UpgradeComponent {


  @Input() trains: MonitoredTrain[];
  @Input() projectId: number;
  @Input() zoom: number;

  @Output() investigateTrain = new EventEmitter<MonitoredTrain>();

  constructor(elementRef: ElementRef, injector: Injector) {
    super('trainsMap', elementRef, injector);
  }

}
